import * as React from "react";
const SvgPayfast = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 141 141" {...props}><path fill="#e54360" d="M58.135.019h-34.62l59.6 70.976-58.86 69.986h34.62l58.61-69.986z" /></svg>;
export default SvgPayfast;